"use strict";

function encryptTextWithKey(text, key) {
	if (!text || !key) return false;

	var textAsBytes = aesjs.utils.utf8.toBytes(text);
	var aes = new aesjs.AES(getEncryptedKeyBuffer(key));
	var encryptedBytes = aes.encrypt(aesjs.padding.pkcs7.pad(textAsBytes));

	return aesjs.utils.hex.fromBytes(encryptedBytes);
}

function getEncryptedKeyBuffer(key) {
	var key256 = CryptoJS.SHA256(key);
	var str = key256.toString(CryptoJS.enc.HEX);
	var bufferArray = [];

	for (var i = 0; i < str.length; i++) {
		if (i % 2 != 0 && i != 0) bufferArray.push(parseInt(str[i - 1] + str[i], 16));
	}

	return bufferArray.slice(0, 16);
}

function decryptHashWithKey(hash, key) {
	if (!hash || !key) return false;

	var encryptedBytes = aesjs.utils.hex.toBytes(hash);
	var aes = new aesjs.AES(getEncryptedKeyBuffer(key));
	var decryptedBytes = aes.decrypt(encryptedBytes);
	return aesjs.utils.utf8.fromBytes(decryptedBytes);
}